import { useLang } from "../../lib/LanguageContext";
import { Star } from "lucide-react";

export default function Testimonials() {
  const { t } = useLang();
  const items = [
    { body: t.testimonials.t1, name: t.testimonials.t1Name, role: t.testimonials.t1Role, tone: "red" },
    { body: t.testimonials.t2, name: t.testimonials.t2Name, role: t.testimonials.t2Role, tone: "orange" },
    { body: t.testimonials.t3, name: t.testimonials.t3Name, role: t.testimonials.t3Role, tone: "ink" },
  ];

  return (
    <section className="py-20 sm:py-28 bg-white border-y border-soft" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <span className="text-xs font-bold uppercase tracking-widest text-brand-red">{t.testimonials.eyebrow}</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {items.map((item, i) => (
            <figure
              key={i}
              className={`rounded-3xl p-7 sm:p-8 border hover:-translate-y-1 transition-transform duration-300 ${
                item.tone === "ink"
                  ? "bg-ink text-white border-ink"
                  : item.tone === "red"
                  ? "bg-[#FEECEE] border-brand-red/20"
                  : "bg-[#FFF4E6] border-brand-orange/20"
              }`}
              data-testid={`testimonial-${i+1}`}
            >
              <div className="flex gap-1 mb-4">
                {[1,2,3,4,5].map((s) => (
                  <Star key={s} className={`w-4 h-4 ${item.tone === 'ink' ? 'text-brand-orange' : 'text-brand-red'}`} fill="currentColor" />
                ))}
              </div>
              <blockquote className={`font-display text-lg sm:text-xl leading-snug ${item.tone === 'ink' ? 'text-white' : 'text-ink'}`}>
                “{item.body}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
                  item.tone === 'ink' ? 'bg-brand-red' : item.tone === 'red' ? 'bg-brand-red' : 'bg-brand-orange'
                }`}>
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className={`font-semibold ${item.tone === 'ink' ? 'text-white' : 'text-ink'}`}>{item.name}</div>
                  <div className={`text-xs ${item.tone === 'ink' ? 'text-white/60' : 'text-ink-muted'}`}>{item.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
